
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.467 42.232c10.518 0 19.043-8.394 19.043-18.75 0-10.355-8.525-18.75-19.043-18.75-10.517 0-19.043 8.395-19.043 18.75 0 10.356 8.526 18.75 19.043 18.75z","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M30.467 34.732c6.31 0 11.426-5.036 11.426-11.25 0-6.213-5.115-11.25-11.426-11.25-6.31 0-11.425 5.037-11.425 11.25 0 6.214 5.115 11.25 11.425 11.25z","stroke":"#3DAFB8","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M41.895 38.481v18.752l-11.428-5.625-11.424 5.625v-18.75","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    